import { styled } from "@mui/material";
import Loader from "../Loader/Loader";
import { useTranslation } from "react-i18next";
import { Button } from "components";
const ContainerStyled = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  "& .loader": {
    marginTop: "1rem",
  },
  "& .btn": {
    marginTop: "0.75rem",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

const ShowMore = ({ isShown, isFetching, onShowMore, showMoreText }) => {
  const { t } = useTranslation();
  return (
    isShown && (
      <ContainerStyled>
        {isFetching ? (
          <Loader className="loader" />
        ) : (
          <Button variant="text" className="btn" onClick={onShowMore}>
            {showMoreText || t("ShowMore.Base")}
          </Button>
        )}
      </ContainerStyled>
    )
  );
};

export default ShowMore;
